<script>
import {Message} from "element-ui";
import {formatDate} from "@/utils/data";
import {officeList} from "@/api/office";
import {
  cancelSync,
  checkOfficeAndEquipmentRef, facilityList,
  firstSync, getSyncParam, pushAutoReport, pushReport,
  putSyncUpdate,
  saveSyncParam, singlePush,
  syncPage, updateSyncParam,
  wasteList,
  exportOli, queryReading
} from "@/api/sync";
import {findAccount, likeAccount} from "@/api/user";
import OliRecord from "@/components/oliRecord.vue";
import OilDeviceList from "@/views/oli/OilDeviceList.vue";
import OilHistory from "@/views/oli/OilHistory.vue";

// 假设的 API 方法，需要根据实际情况替换
export default {
  name: 'OliSync',
  components: {OilHistory, OilDeviceList, OliRecord},
  data() {
    return {
      // 分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0,
      oliList: [],
      visible: false,
      oli: {
        shape: {}
      },
      submitLoading: false,
      searchKeyword: '',
      syncDialogVisible: false,
      oliSync: {
        zbrqTime: [],
        shape: {},
      },
      syncSubmitDisable: false,
      officeList: [],

      syncRules: {
        officeId: [
          {required: true, message: '请选择所属企业', trigger: 'blur'}
        ],
        equipmentCode: [
          {required: true, message: '请输入设备编码', trigger: 'blur'}
        ],
        buyTime: [
            { required: true, message: '请选择设备购买时间', trigger: 'blur' },
            { type: 'date', message: '请选择日期', trigger: ['blur', 'change'] }
        ],
        zbrqTime: [
            { required: true, message: '请选择设备到期时间', trigger: 'blur' },
            { type: 'date', message: '请选择日期', trigger: ['blur', 'change'] }
        ]
      },
      accountOptions: [], // 添加这行
      settingVisible: false,
      deviceSetting: {},
      wasters : [],
      facilities : [],
      settingLoading : false,
      deviceSettingRules: {
        deviation: [
          { required: true, message: '请输入偏差值', trigger: 'blur' }
        ],
        wasterId: [
          { required: true, message: '请选择废物信息模板', trigger: 'change' }
        ],
        facilityId: [
          { required: true, message: '请选择贮存设施模版', trigger: 'change' }
        ],
        wrapperType: [
          { required: true, message: '请选择容器/包装类型', trigger: 'change' }
        ],
        wrapperMaterial: [
          { required: true, message: '请选择容器/包装材质', trigger: 'change' }
        ],
        wrapperSpec: [
          { required: true, message: '请选择容器/包装规格', trigger: 'change' }
        ],
        wrapperCode: [
          { required: true, message: '请输入容器/包装编码', trigger: 'blur' }
        ],
        wrapperNum: [
          { required: true, message: '请输入容器包装数量', trigger: 'blur' },
          { type: 'number', message: '请输入数字', trigger: 'blur' }
        ],
        dangerContent: [
          { required: true, message: '请输入危害成分', trigger: 'blur' }
        ],
        mainContent: [
          { required: true, message: '请输入主要成分', trigger: 'blur' }
        ],
        accountId: [
          { required: true, message: '请选择经办人', trigger: 'change' }
        ]
      },
      officeId : null,
      // 油桶容器类型
      containerShapeOptions : [
          {
            label: '默认',
            value: 'OIL_DRUM'
          },
          {
            label: '圆柱体油桶',
            value: 'CYLINDER'
          },
          {
            label: '立方体油桶',
            value: 'CUBE'
          },
      ]

    }
  },
  mounted() {
    this.getCacheOffice().then((res) => this.fetchOffices());
    this.fetchOliList();
    this.fetchWasteList();
    this.fetchFacilityList();
  },
  methods: {
    async getCacheOffice() {
      const user = localStorage.getItem('user')
      if ( user){
        const id = JSON.parse(user).sysAccount.officeId
        this.officeId = id
        this.oliSync.officeId = id
      }
      return Promise.resolve();
    },


    // 为表格行添加交替样式
    tableRowClassName({row, rowIndex}) {
      return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
    },

    async fetchWasteList(){
      const param = {
        current : 1,
        size : 1000,
        sorted : [
            {
              name: 'createTime',
              type: 'DESC'
            }
        ]
      }
      const resp = await wasteList(param);
      if (resp && resp.code === "0000"){
        this.wasters = resp.result.records || [];
      }
    },

    async fetchFacilityList(){
      const param = {
        current : 1,
        size : 1000,
        sorted : [
            {
              name: 'createTime',
              type: 'DESC'
            }
        ]
      }
      const resp = await facilityList(param);
      if (resp && resp.code === "0000"){
        this.facilities = resp.result.records || [];
      }
    },


    async fetchOliList() {
      try {
        const params = {
          current: this.currentPage,
          size: this.pageSize,
          filter: [
            {
              name: 'deleted',
              type: 'EQ',
              value: 0
            }
          ],
          sorted: [{
            name: 'createTime',
            type: 'DESC'
          }]
        }
        if (this.searchKeyword) {
          params.filter.push({
            name: 'equipmentCode',
            type: 'LIKE',
            value: this.searchKeyword
          })
        }
        const resp = await syncPage(params);
        this.oliList = resp.result.records || [];
        this.total = resp.result.total;

      } catch (e) {
        console.log(e)
        this.oliList = []; // 确保有默认空数组
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchOliList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchOliList()
    },

    async submitOli() {

      this.submitLoading = true;
      try {
          const param = {
            ...this.oli
          }
        console.log('param',param)
          const res = await putSyncUpdate(param);
          if (res && res.code === "0000") {
            Message.success('编辑成功');
          }
        this.cleanOli();
        this.fetchOliList();

      } catch (e) {
        Message.error('操作失败');
      } finally {
        this.submitLoading = false;
      }

      this.cleanOli();
      this.fetchOliList();
      this.$refs.editDrawer.closeDrawer()
    },

    async deleteOli(id) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          // deleteOliById(id).then( res => {
          //   if (res && res.code === "0000") {
          //     Message.success(`删除成功`);
          //     this.cleanOli();
          //     this.fetchOliList();
          //   }
          // })
          Message.success(`删除成功`);
          this.cleanOli();
          this.fetchOliList();
        } catch (e) {
          Message.error('删除失败');
        }
      }).catch(() => {

      });

    },

    handleEdit(item) {
      this.oli = {
        ...item,
      }
      if (!this.oli.shape){
        this.oli.shape = {}
        this.oli.containerShape = 'OIL_DRUM'
      }

      this.visible = true

    },

    cleanOli() {
      this.oli = {
        shape: {},
        containerShape : 'OIL_DRUM'
      }
      this.currentPage = 1
    },

    handleSearch() {
      this.cleanOli();
      this.fetchOliList()
    },

    async openSettingDrawer(data) {
      this.settingVisible = true
      const resp = await getSyncParam(data.equipmentId)
      if (resp && resp.code === "0000" && resp.result){
        this.deviceSetting = resp.result
        // 查询一次经办人
        if (this.deviceSetting.accountId){
          const res = await findAccount(this.deviceSetting.accountId)
          this.deviceSetting.accountName = res.result.username
          this.accountOptions = [{
            id: this.deviceSetting.accountId,
            name: this.deviceSetting.accountName
          }]
        }
      }else {
        this.deviceSetting.equipmentId = data.equipmentId
      }
      this.deviceSetting.syncId = data.id
    },

    handleCommand(command, data){
      switch ( command){
        case 'edit' : {
          this.handleEdit(data)
          break;
        }
        case 'setting' : {
          this.openSettingDrawer(data)
          break;
        }
        case 'push' : {
          this.$confirm('<p>确定要触发上报吗</p><p>系统会<span style="color: red">主动查询传感器数据</span>后判断是否上报</p>', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }).then(async () => {
            const resp = await singlePush(data.id);
            if (resp && resp.code === "0000") {
              await this.fetchOliList();
            }
          })
          break;
        }
        case  'auto': {
          this.$confirm('<p>确定要自动同步市平台数据吗？</p><p>开通后由传感器自动获取产生量后自动上报</p>'
              , '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }).then(async () => {
            const resp = await pushAutoReport(data.id);
            if (resp && resp.code === "0000") {
              await this.fetchOliList();
            }
          })
          break;
        }
        case 'cancel' : {
          this.$confirm('确定要撤销市平台的记录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const resp = await cancelSync(data.id);
            if (resp && resp.code === "0000") {
              Message.success('撤销成功');
              this.cleanOli();
              await this.fetchOliList();
            }else {
              Message.error("撤销失败，原因：" + resp.message,{duration: 5000});
            }

          })
          break;
        }
        case 'queryValue' : {
          this.handleQueryValue(data)
          break;
        }
        case 'queryHistory' :{
          this.$refs.historyRef.open(data.equipmentId)
          break
        }
      }
    },

    async handleQueryValue(data) {
      const resp = await queryReading(data.equipmentId);
      if (resp) {
        this.$message.success(`当前最新读数为 ：${resp.val}`)
      }
    },

    // 获取企业
    async fetchOffices() {

      const param = {
        current : 1,
        size : 1000,
        "filter": [
          {
            "name": "enabled",
            "value": 1,
            "type": "EQ"
          }
        ],
        sorted: [
          {
            "name": "createdTime",
            "type": "DESC"
          }
        ],
      }

      try {
        const res = await officeList(param);
        if (res && res.code === "0000"){
          this.officeList = res.result.records;
        }
      } catch (error) {
        console.error('获取企业列表失败：', error);
        this.$message.error('加载企业列表失败，请重试');
      }
    },

    changeOffice(value) {
      const selectedOffice = this.officeList.find(office => office.id === value);
      if (selectedOffice) {
        this.oliSync.officeName = selectedOffice.name;
      }
      this.checkOfficeAndEquipment();
    },

    async checkOfficeAndEquipment(){
      if (!this.oliSync.officeId || !this.oliSync.equipmentCode) {
        return ;
      }
      const param = {
        officeId : this.oliSync.officeId,
        equipmentCode : this.oliSync.equipmentCode
      }
      const resp = await checkOfficeAndEquipmentRef(param)
      if (resp && resp.code === "0000"){
        this.syncSubmitDisable = !!!resp.result;
      }
    },

    async handleSync (){
      const param = {
        ...this.oliSync,
        buyDate : formatDate(this.oliSync.buyTime,'yyyy-MM-dd 00:00:00'),
        protectStart : formatDate(this.oliSync.zbrqTime[0],'yyyy-MM-dd 00:00:00'),
        protectEnd : formatDate(this.oliSync.zbrqTime[1],'yyyy-MM-dd 23:59:59'),
        officeName: this.officeList.find(office => office.id === this.oliSync.officeId).name || ''
      }
      delete param.zbrqTime;
      delete param.buyTime;
      const resp = await firstSync(param);
      if (resp && resp.code === "0000"){
        Message.success('上报成功');
        this.cleanOli();
        this.fetchOliList();
        this.oliSync = {
          zbrqTime: [],
          shape: {},
        }
        this.syncDialogVisible = false;
      }else {
        Message.error(resp.msg)
      }
    },

    // 加载初始账户选项
    async loadInitialAccounts() {
      await this.queryAccountForSelect( '')
    },
    // 用于 el-select 的远程搜索
    async queryAccountForSelect(queryString) {
      console.log('queryAccountForSelect', queryString)
      const response = await likeAccount(queryString)
      if (response && response.result) {
        this.accountOptions = response.result.map(item => ({
          'name': `${item.username}${item.mobileNo ? `  | ${item.mobileNo}` : ''}`,
          'id': item.id
        }))
      }
    },

    // 处理 el-select 选择事件
    handleAccountSelectForSelect(value) {
      if (value) {
        const selectedAccount = this.accountOptions.find(account => account.id === value);
        if (selectedAccount) {
          this.deviceSetting.accountId = value;
          this.deviceSetting.accountName = selectedAccount.name;
        }
      }
    },

    async submitSetting(){
      this.submitLoading = true;
      if (!this.deviceSetting.accountId){
        Message.warning('请选择经办人');
        return
      }
      try {
        const param = {
          ...this.deviceSetting,

        }
        console.log('param',param)
        const resp = param.id ?  await updateSyncParam( param) : await saveSyncParam(param);

        if (resp && resp.code === "0000"){
          Message.success('保存成功');
        }
      }catch ( e){
        Message.error('操作失败');
      }finally {
        this.submitLoading = false;
        this.settingVisible = false;
      }
    },

    openRecord(item) {
      this.$refs.oldRecordRef.open(item.equipmentId)
    },

    renderHeaderForStatus(h, { column }) {
      return h('div', [
        h('span', column.label),
        h('el-tooltip', {
          props: {
            content: h('div', [
              h('div', '已创建：本地库已创建记录，未上报市平台'),
              h('div', '完成配置：代表设备已上报市平台'),
              h('div', '自动上报：设备已配置参数，且开启传感器上报')
            ]),
            placement: 'top'
          }
        }, [
          h('i', {
            class: 'el-icon-question',
            style: 'margin-left: 5px; cursor: pointer; color: #909399;'
          })
        ])
      ]);
    },

    async handleExport(){
      try {
        const response = await exportOli();
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const contentDisposition = response.headers ? response.headers['content-disposition'] || response.headers['Content-Disposition'] : '';
        let filename = '导出台账.xlsx';

        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*=utf-8''(.+?)(?:;|$)/i);
          if (match && match[1]) {
            filename = decodeURIComponent(match[1]);
          } else {
            const filenameMatch = contentDisposition.match(/filename=(.+?)(?:;|$)/i);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/["']/g, '');
            }
          }
        }

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

        Message.success('导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        Message.error('导出失败');
      }
    },

    openList() {
      this.$refs.deviceListRef.open()
    },

  },
}
</script>

<template>
  <div>
    <el-card class="main-card">
      <div class="card-header">
        <div style="display: flex; align-items: center; gap: 16px;">
          <!-- 搜索区域 -->
          <div class="filter-bar">
            <el-input size="small" v-model="searchKeyword" placeholder="搜索设备编码" clearable class="search-input" @keyup.enter="handleSearch">
              <el-button size="small" slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
          </div>
        </div>
        <el-row>
          <el-button type="primary" size="small" @click="syncDialogVisible = true" v-if="officeId !== 0">设备上报</el-button>
          <el-button type="warning" size="small" @click="openList" v-show="officeId !== 0">查询已上报设备</el-button>
          <el-button size="small" @click="handleExport">导出</el-button>
        </el-row>
      </div>

      <el-table :data="oliList" border class="device-table" stripe highlight-current-row
                :row-class-name="tableRowClassName">
        <el-table-column prop="officeName" label="所属企业" min-width="100" show-overflow-tooltip/>
        <el-table-column prop="equipmentCode" label="设备编码" min-width="100" show-overflow-tooltip/>
        <el-table-column prop="statusDesc" label="进程状态" min-width="100"  :render-header="renderHeaderForStatus">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'AUTO_REPORT' ? 'success' : ''">{{scope.row.statusDesc}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="jwd" label="安装定位" show-overflow-tooltip/>
        <el-table-column prop="buyDate" label="购买日期" show-overflow-tooltip />
        <el-table-column prop="deviceSpec" label="设备规格"/>
        <el-table-column prop="currentHeight" label="当前高度" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.currentHeight">{{ scope.row.currentHeight }}cm</span>
          </template>
        </el-table-column>
        <el-table-column prop="currentWeight" label="当前重量" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.currentWeight">{{ scope.row.currentWeight }}kg</span>
          </template>
        </el-table-column>
        <el-table-column prop="fillRate" label="填充率">
          <template slot-scope="scope">
            <span v-if="scope.row.fillRate">{{ scope.row.fillRate }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="alarmFillRate" label="报警值"/>
        <el-table-column prop="sid" label="市平台ID" min-width="100" show-overflow-tooltip/>
        <el-table-column prop="syncStatus" label="上报状态" min-width="150">
          <template slot-scope="scope">
            <el-row type="flex" :gutter="20" style="padding: 0 10px" align="bottom">
              <el-tag :type="scope.row.syncStatus === 1 ? 'success' : 'danger'">{{ scope.row.syncStatus === 1 ? '成功' : '失败' }}</el-tag>
              <el-popover
                  placement="top-start"
                  title="失败原因"
                  width="200"
                  trigger="hover"
                  :content="scope.row.syncMessage"
                  :hidden="scope.row.syncStatus === 1 "
              >
                <el-link  slot="reference" type="info" style="margin-left: 20px; font-size: 12px">失败原因</el-link>
              </el-popover>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="上报时间" min-width="100" show-overflow-tooltip/>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-row :gutter="8">
              <el-button size="mini" type="text" @click="handleEdit(scope.row)"  v-if="officeId !== 0">编辑</el-button>
              <el-button size="mini" type="text" @click="openRecord(scope.row)">台账记录</el-button>
              <el-dropdown @command="(command) => handleCommand(command, scope.row)"  v-if="officeId !== 0">
                <el-button size="mini" type="text" style="margin-left: 10px; color: #4b5563;">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item command="setting">设置同步参数</el-dropdown-item>
                  <el-dropdown-item command="push">触发传感器上报</el-dropdown-item>
                  <el-dropdown-item command="auto">开启自动上报</el-dropdown-item>
                  <el-dropdown-item command="cancel" style="color: #F56C6C"><span>撤销上报记录</span></el-dropdown-item>
                  <el-dropdown-item command="queryValue">查询最新读数</el-dropdown-item>
<!--                  <el-dropdown-item command="queryHistory">查询历史读数</el-dropdown-item>-->

                </el-dropdown-menu>
              </el-dropdown>
            </el-row>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"
                       class="pagination"></el-pagination>
      </div>


      <oli-record ref="oldRecordRef" :office-id="officeId" />
    </el-card>

    <el-drawer
        title="编辑"
        :visible.sync="visible"
        direction="rtl"
        ref="editDrawer"
    >
      <div class="edit-container">
        <el-form ref="oliForm" :model="oli" label-width="120px" >
          <el-form-item label="使用企业名称" prop="officeName">
            <el-input v-model="oli.officeName" readonly disabled/>
          </el-form-item>
          <el-form-item label="设备编码" prop="equipmentCode">
            <el-input v-model="oli.equipmentCode" readonly disabled/>
          </el-form-item>
          <el-form-item label="安装定位" prop="location">
            <el-input v-model="oli.jwd" placeholder="格式：113.23,34.56" disabled />
          </el-form-item>
          <el-form-item label="购买日期" prop="buyDate">
            <el-date-picker v-model="oli.buyDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" disabled/>
          </el-form-item>
          <el-form-item label="设备规格" prop="deviceSpec">
            <el-input v-model="oli.deviceSpec" clearable/>
          </el-form-item>
          <el-form-item label="当前高度(mm)" prop="currentHeight">
            <el-input v-model.number="oli.currentHeight" type="number" clearable/>
          </el-form-item>
          <el-form-item label="当前重量(kg)" prop="currentWeight">
            <el-input v-model.number="oli.currentWeight" type="number" clearable/>
          </el-form-item>
          <el-form-item label="填充率(%)" prop="fillRate">
            <el-input v-model.number="oli.fillRate" max="100" type="number" clearable/>
          </el-form-item>
          <el-form-item label="报警值(%)" prop="alarmFillRate">
            <el-input v-model.number="oli.alarmFillRate"  type="number" clearable/>
          </el-form-item>

          <el-form-item label="容器类型" prop="containerShape" required>
            <el-select v-model="oli.containerShape" placeholder="请选择油桶容器类型" clearable >
              <el-option
                  style="width: 100%"
                  v-for="item in containerShapeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="容器参数" prop="shapeCol" v-show="oli.containerShape && oli.containerShape !== ''">
            <template v-if="oli.containerShape === 'CYLINDER'">
              <el-row style="width: 100%" type="flex" >
                <el-input v-model="oli.shape.radius" placeholder="半径(cm)" clearable style="margin-right: 10px"/>
                <el-input v-model="oli.shape.height" placeholder="桶身高度(cm)" clearable/>
              </el-row>
            </template>
            <template v-else-if="oli.containerShape === 'CUBE'">
              <el-row style="width: 100%" type="flex">
                <el-input v-model="oli.shape.length" placeholder="长(cm)" clearable style="margin-right: 10px"/>
                <el-input v-model="oli.shape.width" placeholder="宽(cm)" clearable style="margin-right: 10px"/>
                <el-input v-model="oli.shape.height" placeholder="桶身高度(cm)" clearable/>
              </el-row>
            </template>
            <template v-else>
              <el-row style="width: 100%" type="flex">
                <el-input v-model="oli.shape.height" placeholder="桶身高度(cm)" clearable style="margin-right: 10px"/>
                <el-input v-model="oli.oilGg" placeholder="示例：10L、20L" clearable/>
              </el-row>
            </template>
          </el-form-item>

          <el-form-item label="市平台ID" prop="sid" required>
            <el-input v-model="oli.sid" clearable/>
          </el-form-item>
        </el-form>
        <div class="edit-footer">
          <el-button @click="$refs.editDrawer.closeDrawer()">取 消</el-button>
          <el-button type="primary" @click="submitOli" :loading="submitLoading">
            {{ submitLoading ? '提交中 ...' : '提 交' }}
          </el-button>
        </div>
      </div>
    </el-drawer>

    <el-drawer title="设备上报" :visible.sync="syncDialogVisible"  direction="rtl" size="40%">
      <div class="edit-container">
        <el-form :model="oliSync" label-width="100px" :rules="syncRules">
          <el-form-item label="所属企业" prop="officeId">
            <el-select v-model="oliSync.officeId" :disabled="!!officeId" placeholder="请选择企业" clearable class="form-select" @change="changeOffice" style="width: 100%">
              <el-option v-for="item in officeList" :key="item.id" :label="item.name"
                         :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="设备编码" prop="equipmentCode"  style="width: 100%">
            <el-input v-model="oliSync.equipmentCode" placeholder="请输入设备编码" clearable @blur="checkOfficeAndEquipment">
              <div slot="suffix" style="font-size: 12px">
                <div v-if="oliSync.equipmentCode">
                  <span v-if="!syncSubmitDisable" style="color: #52c41a">设备可以上报</span>
                  <span v-else style="color: #ff4d4f">设备与所属企业关联不一至</span>
                </div>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item label="购买日期" prop="buyTime">
            <el-date-picker v-model="oliSync.buyTime" type="date" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="质保时间" prop="zbrqTime">
            <el-date-picker
                v-model="oliSync.zbrqTime"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间" />
          </el-form-item>
          <el-form-item label="设备供应商" prop="supplier">
            <el-input v-model="oliSync.supplier" placeholder="请输入设备供应商" clearable/>
          </el-form-item>
          <el-form-item label="标签类型" prop="labelType">
            <el-input v-model="oliSync.labelType" placeholder="1-旧版标签纸；2-新版标签纸" clearable/>
          </el-form-item>
          <el-form-item label="打印机规格" prop="printerGg">
            <el-input v-model="oliSync.printerGg" placeholder="1-10cm*10cm；2-15cm*15cm；3-20cm*20cm" clearable/>
          </el-form-item>
          <el-form-item label="容器类型" prop="containerShape" required>
            <el-select v-model="oliSync.containerShape" placeholder="请选择油桶容器类型" clearable >
              <el-option
                  style="width: 100%"
                  v-for="item in containerShapeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="容器参数" prop="shapeCol" v-show="oliSync.containerShape && oliSync.containerShape !== ''">
            <template v-if="oliSync.containerShape === 'CYLINDER'">
              <el-row style="width: 100%" type="flex" >
                <el-input v-model="oliSync.shape.radius" placeholder="半径(cm)" clearable style="margin-right: 10px"/>
                <el-input v-model="oliSync.shape.height" placeholder="桶身高度(cm)" clearable/>
              </el-row>
            </template>
            <template v-else-if="oliSync.containerShape === 'CUBE'">
              <el-row style="width: 100%" type="flex">
                <el-input v-model="oliSync.shape.length" placeholder="长(cm)" clearable style="margin-right: 10px"/>
                <el-input v-model="oliSync.shape.width" placeholder="宽(cm)" clearable style="margin-right: 10px"/>
                <el-input v-model="oliSync.shape.height" placeholder="桶身高度(cm)" clearable/>
              </el-row>
            </template>
            <template v-else>
              <el-row style="width: 100%" type="flex">
                <el-input v-model="oliSync.shape.height" placeholder="桶身高度(cm)" clearable style="margin-right: 10px"/>
                <el-input v-model="oliSync.oilGg" placeholder="示例：10L、20L" clearable/>
              </el-row>
            </template>
          </el-form-item>
<!--          <el-form-item label="油桶规格" prop="oilGg" required>
            <el-input v-model="oliSync.oilGg" placeholder="示例：10L、20L" clearable/>
          </el-form-item>-->
          <el-form-item label="设备验证码" prop="deviceCaptcha">
            <el-input v-model="oliSync.deviceCaptcha" placeholder="请输入设备验证码" clearable/>
          </el-form-item>
          <el-form-item label="软件版本" prop="softVersion">
            <el-input v-model="oliSync.softVersion" placeholder="请输入软件版本" clearable/>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="end">
          <el-button type="primary" :disabled="syncSubmitDisable" @click="handleSync" style="width: 180px">提交上报</el-button>
        </el-row>
      </div>
    </el-drawer>

    <el-drawer title="设置同传参数" :visible.sync="settingVisible"  direction="rtl" show-close size="40%">
      <el-form label-width="150px" :model="deviceSetting" style="width: 90%" >
        <el-form-item required label="偏差值" prop="deviation">
          <el-input v-model="deviceSetting.deviation" placeholder="请输入允许传感器偏差值" clearable>
            <div slot="prepend">正负</div>
            <div slot="append">cm</div>
          </el-input>
        </el-form-item>
        <el-form-item required label="废物信息模板" prop="wasterId">
          <el-select v-model="deviceSetting.wasterId" placeholder="请选择废物信息模板" clearable style="width: 100%">
            <el-option v-for="item in wasters" :key="item.id" :value="item.id" :label="`${item.fwdldm} | ${item.fwdlmc}`" >
              <span style="float: left">{{ item.fwdldm }} | {{item.fwdlmc}}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.fwxxmc }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item required label="贮存设施模版" prop="facilityId">
          <el-select v-model="deviceSetting.facilityId" placeholder="请选择贮存设施" clearable style="width: 100%">
            <el-option v-for="item in facilities" :key="item.id" :value="item.id" :label="`${item.scssbh}  | ${item.scssmc}`" />
          </el-select>
        </el-form-item>

        <el-form-item required label="容器/包装类型" prop="wrapperType">
           <el-select v-model="deviceSetting.wrapperType">
             <el-option value="0" label="槽罐" />
             <el-option value="1" label="袋装" />
             <el-option value="2" label="装桶" />
             <el-option value="9" label="其他" />
           </el-select>
        </el-form-item>

        <el-form-item required label="容器/包装材质" prop="wrapperMaterial">
          <el-select v-model="deviceSetting.wrapperMaterial" clearable>
            <el-option value="1" label="金属" />
            <el-option value="2" label="塑料" />
            <el-option value="3" label="复合材料" />
            <el-option value="9" label="其他材质" />
          </el-select>
        </el-form-item>

        <el-form-item required label="容器/包装规格" prop="wrapperSpec">
          <el-select v-model="deviceSetting.wrapperSpec" clearable>
            <el-option value="1" label="<=25L" />
            <el-option value="2" label="50L" />
            <el-option value="3" label="200L" />
            <el-option value="4" label="1000L" />
            <el-option value="9" label="其他" />
          </el-select>
        </el-form-item>

        <el-form-item required label="容器/包装编码" prop="wrapperCode">
          <el-input v-model="deviceSetting.wrapperCode" placeholder="请输入容器/包装编码" clearable />
        </el-form-item>

        <el-form-item required label="容器包装数量" prop="wrapperNum">
          <el-input v-model="deviceSetting.wrapperNum" type="number" min="1" clearable />
        </el-form-item>


        <el-form-item label="危害成分" prop="dangerContent">
          <el-input v-model="deviceSetting.dangerContent" placeholder="请输入危害成分" clearable />
        </el-form-item>

        <el-form-item label="主要成分" prop="mainContent">
          <el-input v-model="deviceSetting.mainContent" placeholder="请输入危害成分" clearable />
        </el-form-item>

        <el-form-item label="经办人" prop="accountId" required>
          <el-select
              v-model="deviceSetting.accountName"
              :placeholder="deviceSetting.accountName ? `已选-${deviceSetting.accountName}` : '请输入用户名/账号名/手机号'"
              filterable
              remote
              reserve-keyword
              :remote-method="queryAccountForSelect"
              @focus="loadInitialAccounts"
              @change="handleAccountSelectForSelect"
              style="width: 100%"
          >
            <el-option
                v-for="item in accountOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>


      </el-form>
      <el-row type="flex" justify="end" >
        <el-button type="primary" @click="submitSetting" :loading="settingLoading"  style="width: 100px;margin-right: 20px" >提交设置</el-button>
      </el-row>
    </el-drawer>

    <oil-device-list ref="deviceListRef" />
    <oil-history ref="historyRef" />

  </div>

</template>

<style scoped>

/* 主卡片样式 */
.main-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}


.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.edit-container {
  display: flex;
  flex-direction: column;
  padding: 12px;
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  .edit-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    padding: 12px;
    position: absolute;
    bottom: 0;
    right: 0;
    box-sizing: border-box;
  }
}

.table-row-even {
  background-color: #fff;
}

.table-row-odd {
  background-color: #fafafa;
}

/* 搜索区域 */
.filter-bar {
  display: flex;
  align-items: center;
}

.search-input {
  width: 200px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

}

/* 分页样式 */
.pagination-container {
  margin: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f2f5;
  text-align: right;
}

.waste-option{
  display: flex;
  flex-direction: column;
  gap: 2px;
  .option-title{
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  }
  .option-desc{
    font-size: 8px;
    display: flex;
    justify-content: space-between;
  }
}


</style>
